<template>
  <div class="t-document_upload">
    <div class="t-document__progress" v-if="!data.error"><span :style="'width:' + data.progress + '%'"></span></div>
    <!--<button class="t-document__reload" @click.prevent="Reload()" v-if="data.error">-->
      <!--<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--<path d="M16.4185 6C15.2317 3.06817 12.3574 1 9.00003 1C5.64265 1 2.76832 3.06817 1.58154 6M16.4185 12C15.2317 14.9318 12.3574 17 9.00003 17C5.64265 17 2.76832 14.9318 1.58154 12M16.4185 12L17 15M16.4185 12L13.5 13M1.58154 6L1 3M1.58154 6L4.5 5" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
      <!--</svg>-->
    <!--</button>-->
    <!--<button class="t-document__cancel" @click.prevent="Cancel()">-->
      <!--<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--<path d="M1 1L13 13M13 1L1 13" stroke="#52A8F2" stroke-width="2"/>-->
      <!--</svg>-->
    <!--</button>-->
  </div>
</template>

<script>
    export default {
        props: ['data'],
        methods: {
            Cancel(){
                this.$emit('cancelUpload')
            },
            Reload(){}
        }
    }
</script>

<style lang="sass">
.t-document_upload
  padding-bottom: 10px
  min-width: 200px
  margin-top: 50px
.t-document__reload
  width: 40px
  height: 40px
  display: flex
  align-items: center
  justify-content: center
  cursor: pointer
  background: transparent
  border: none
  position: absolute
  right: 40px
  top: 50%
  margin-top: -30px
  outline: none
.t-document__cancel
  width: 40px
  height: 40px
  display: flex
  align-items: center
  justify-content: center
  cursor: pointer
  background: transparent
  border: none
  position: absolute
  right: 0
  top: 50%
  margin-top: -30px
  outline: none
.t-document__progress
  height: 5px
  background: rgba(191, 191, 191, 0.2)
  border-radius: 1px
  span
    display: block
    height: 5px
    background: $blue
    border-radius: 1px
@media (max-width: 769px)
  .t-document__cancel, .t-document__reload
    margin-top: 0
    top: 0
</style>


// WEBPACK FOOTER //
// src/vue_components/DocUpload.vue